<template>
  <div id="app" ref="homeref">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  
  },
  data() {
    return {
      Specifications: {
        //定义的宽高比例，初始为1
        ww: 1,
        wh: 1,
        //根据class="home"里面定义的宽高进行作为初始宽高进行计算
        width: 1920, //自定义
        height: 960, //自定义
      },
    };
  },
  methods: {
    getScale() {
      // 获取到缩放比例
      this.Specifications.wh = window.innerHeight / this.Specifications.height;
      this.Specifications.ww = window.innerWidth / this.Specifications.width;
      //将比例设置进dom元素中
      this.$refs.homeref.style.setProperty("--scaleX", this.Specifications.ww);
      this.$refs.homeref.style.setProperty("--scaleY", this.Specifications.wh);
    },
  },
  mounted() {
    this.getScale();
    var than = this;
    window.addEventListener("resize", function () {
      than.getScale();
    });
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #112024;
  width: 1920px;
  height: 960px;
  transform: scale(var(--scaleX), var(--scaleY));
  transform-origin: 0 0;
  left: 50%;
  top: 50%;
  transition: 0.3s;
}
#mainbox {
  height: 100%;
  width: 100%;
  position: relative;
}

</style>
